import Vue from 'vue'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import './assets/index.css'
import './assets/icon/iconfont.css'
import App from './App.vue'
import router from './router'
import qs from 'qs';
Vue.prototype.$qs = qs
Vue.config.productionTip = false

import VideoPlayer from 'vue-video-player'
import 'vue-video-player/src/custom-theme.css'
import 'video.js/dist/video-js.css'
import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'

Vue.use(VideoPlayer)
Vue.use(ElementUI);
Vue.use(Viewer, {
  defaultOptions: {
    zIndex: 9999
  }
})

Vue.config.productionTip = false

/* 路由发生变化修改页面title */
router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    // document.title = to.meta.title
    // console.log(to.meta.title)
  }
  next()
})

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
